module.exports = __webpack_public_path__ + "static/media/i-am-that-i-am2.4853b55c.jpg";